import { AlertTriangle } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { HoverPopoverIcon } from '@/components/hover-popover-icon';

interface DataWarningIconProps {
  version: string;
  percentage: number;
}

export function DataWarningIcon({ version, percentage }: DataWarningIconProps) {
  const { LL } = useI18nContext();
  const message = LL.metricsPage.warnings.dataSufficiency({
    version,
    percentage,
  });

  return (
    <HoverPopoverIcon
      icon={AlertTriangle}
      ariaLabel={LL.metricsPage.warnings.count({ count: 1 })}
      message={message}
      size="md"
    />
  );
}
